import { addBlockMetadata, ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"
import { useMemo } from "react"
import { PageProvider } from "../contexts/PageContext"
import { SiteFooter } from "@components/site/SiteFooter"

export default defineView("single-film", (props) => {
  const content = useMemo(() => {
    addBlockMetadata(props.film?.contentBlocks)
    const sidebar = props.film?.contentBlocks.find((block) => block.slug === "film/film-sidebar")?.innerBlocks
    return (
      <ContentBlocks
        blocks={props.film?.contentBlocks}
        wrapBlock={(children, { current }) => {
          if (current.slug === "film/film-sidebar") return <></>
          if (current.slug === "film/film-contents")
            return (
              <div className="grid-auto">
                <div className="cols-film-main" data-film-main>
                  <ContentBlocks blocks={current.innerBlocks} />
                </div>
                <div className="cols-film-sidebar flex flex-col gap-6" data-film-sidebar>
                  <ContentBlocks blocks={sidebar} />
                </div>
              </div>
            )
          return children
        }}
      />
    )
  }, [props.film?.contentBlocks])

  return (
    <PageProvider theme={"yellow"}>
      <div>{content}</div>
      <SiteFooter />
    </PageProvider>
  )
})
